import React, { useState } from 'react';
import axios from 'axios';

const backendURL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

const LoginPage = () => {
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [registros, setRegistros] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [error, setError] = useState('');
  const [currentView, setCurrentView] = useState('posiciones'); // 'posiciones' o 'usuarios'

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Datos enviados:', formData);
    try {
      const response = await axios.post(`${backendURL}/api/login`, formData);
      if (response.data.success) {
        setIsLoggedIn(true);
        fetchRegistros();
        fetchUsuarios();
      }
    } catch (err) {
      console.error('Error en el login:', err);
      setError('Usuario o contraseña incorrectos.');
    }
  };

  const fetchRegistros = async () => {
    try {
      const response = await axios.get(`${backendURL}/api/grupos`);
      console.log(response.data);
      setRegistros(response.data);
    } catch (err) {
      setError('Error al obtener los registros.');
    }
  };

  const fetchUsuarios = async () => {
    try {
      const response = await axios.get(`${backendURL}/api/users`);
      console.log(response.data);
      setUsuarios(response.data);
    } catch (err) {
      setError('Error al obtener los usuarios.');
    }
  };

  if (!isLoggedIn) {
    return (
      <div className="container contenedorlogin">
        <h2>Inicio de Sesión</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="username" className="form-label">Usuario</label>
            <input
              type="text"
              className="form-control"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">Contraseña</label>
            <input
              type="password"
              className="form-control"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="btn btnVerde">Iniciar Sesión</button>
        </form>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-center mb-4">
        <button
          className={`btn ${currentView === 'posiciones' ? 'btnVerde' : 'btnGris'} me-2`}
          onClick={() => setCurrentView('posiciones')}
        >
          Ver Posiciones
        </button>
        <button
          className={`btn ${currentView === 'usuarios' ? 'btnVerde' : 'btnGris'}`}
          onClick={() => setCurrentView('usuarios')}
        >
          Ver Usuarios
        </button>
      </div>

      {currentView === 'posiciones' && (
        <div>
          <h2>Posiciones Utileros</h2>
          {registros.length > 0 ? (
            <ul className="list-group">
              {registros.map((registro) => (
                <li key={registro._id} className="list-group-item d-flex justify-content-between align-items-center">
                  <span>{registro.nombre} - {registro.estilo}</span>
                  <span>Puntos: {registro.puntos}</span>
                </li>
              ))}
            </ul>
          ) : (
            <p>No hay registros disponibles.</p>
          )}
        </div>
      )}

      {currentView === 'usuarios' && (
        <div>
          <h2>Usuarios Registrados</h2>
          {usuarios.length > 0 ? (
            <ul className="list-group">
              {usuarios.map((usuario) => (
                <li key={usuario._id} className="list-group-item">
                  {usuario.nombre} - {usuario.mail}
                </li>
              ))}
            </ul>
          ) : (
            <p>No hay usuarios registrados.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default LoginPage;
